import { render } from "./InvestorDeep.vue?vue&type=template&id=e3c7a8fa"
import script from "./InvestorDeep.vue?vue&type=script&lang=js"
export * from "./InvestorDeep.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__